import React, { useEffect, useState } from 'react'
import HostingCompleteProfile from '../components/hosting/HostingCompleteProfile';
import HostinginJatick from '../components/hosting/HostinginJatick';
import JatickRules from '../components/hosting/JatickRules';
import CheckoutStepbar from '../components/layouts/checkout/CheckoutStepbar';

const Hosting = () => {
    const [phase, setPhase] = useState(1);
    const steps = [
      {
        PhaseNumber: 1,
        phaseName: "میزبانی در جاتیک"
      },
      {
        PhaseNumber: 2,
        phaseName: "قوانین جاتیک"
      },
      {
        PhaseNumber: 3,
        phaseName: "تکمیل پروفایل"
      }
    ];
    const nextStep = (num)=>{
      setPhase(num)
    }
    useEffect(() => {
      
      window.scrollTo(0, 0);

    }, [phase])
    
    const rendercomponent = ()=>{
      switch (phase) {
        case 1:
          return <HostinginJatick  nextStep={nextStep}/>
         
          case 2 : return <JatickRules nextStep={nextStep} />
          case 3 : return <HostingCompleteProfile nextStep={nextStep} />

      
        default:
          break;
      }
    }
  return (
    <div className='hosting'>
        <div className='hosting--header'>
            <div className='hosting--header-title'>
                <h2>نحوه میزبانی در جاتیک</h2>
                <p>مطالب زیر در میزبانی شما و کسب درآمد در جاتیک کمک بسزایی دارد .</p>
            </div>
        <CheckoutStepbar PhaseNum={phase} PhaseList={steps} />
        </div>
       {rendercomponent()}
    </div>
  )
}

export default Hosting